(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
const hgFooterClock = new Intl.DateTimeFormat('en-AU', {timeZone:'Australia/Melbourne',weekday:'short',hour:'2-digit',minute:'2-digit',hourCycle:'h23'});
const hgFooterDays = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
const hgFooterHours = {fitzroy:[[600,1020],[660,1050],null,[660,1050],[660,1050],[660,1050],[600,1020]],qvm:[[540,960],null,[450,900],null,[450,900],[450,900],[420,960]]};
const updateHgFooterStores = () => {
 const parts = Object.fromEntries(hgFooterClock.formatToParts(new Date()).map(({type,value})=>[type,value]));
 const day = hgFooterDays.indexOf(parts.weekday);
 const minutes = Number(parts.hour)*60+Number(parts.minute);
 document.querySelectorAll('[data-hg-store]').forEach(store=>{
  const hours = hgFooterHours[store.dataset.hgStore]?.[day];
  const open = Boolean(hours && minutes >= hours[0] && minutes < hours[1]);
  store.dataset.open = String(open);
  store.querySelector('[data-hg-status-text]').textContent = open ? store.dataset.openLabel : store.dataset.closedLabel;
  store.querySelector('.hg-visit-footer__status').hidden = false;
 });
};
updateHgFooterStores();
if(window.hgFooterStoresTimer) window.clearInterval(window.hgFooterStoresTimer);
window.hgFooterStoresTimer = window.setInterval(updateHgFooterStores,60000);
document.addEventListener('shopify:section:load',updateHgFooterStores);
document.addEventListener('visibilitychange',updateHgFooterStores);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hg-bean-to-bar"] && !Shopify.designMode) return;
  try {
    
function initHgVideos(root) {
  root.querySelectorAll('[data-hg-video]').forEach(container => {
    if (container.dataset.ready) return;
    container.dataset.ready = 'true';
    const video = container.querySelector('video');
    const button = container.querySelector('button');
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const sync = () => { button.textContent = video.paused ? button.dataset.play : button.dataset.pause; };
    video.controls = false;
    video.muted = true;
    button.hidden = false;
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    button.addEventListener('click', () => {
      if (video.paused) video.play().catch(sync);
      else video.pause();
    });
    motion.addEventListener('change', () => { if (motion.matches) video.pause(); });
    if (!motion.matches) video.play().catch(sync);
    sync();
  });
}
initHgVideos(document);
document.addEventListener('shopify:section:load', event => initHgVideos(event.target));

  } catch(e) { console.error(e); }
})();
})();
